module.exports = __webpack_public_path__ + "img/Etape 2.a2f91872.png";